import Breadcrumb from "../../components/Breadcrumbs/Breadcrumb"
import ExamAddWizard from "../../components/Exams/ExamAddWizard"

const ExamAdd = () => {
    return (
        <>
            <Breadcrumb pageName="Add Exam" />
            <div className="grid grid-cols-12 gap-4">
                <ExamAddWizard />
            </div>
        </>
    )
}

export default ExamAdd